export default {
  hizli_triple_word: "Açıq kartdakı söz qapalı kartlarda varmı?",
  hizli_triple_shape: "Açıq kartdakı formalar və rənglər qapalı kartlarda mövcuddurmu?",
  kar_title: "Qar adamının köməyinizə ehtiyacı var!",
  kar_desc: "Qar dənəcikləri yerə düşməzdən əvvəl problemləri həll etməlisiniz, Problemləri həll etmək üçün klaviaturadakı rəqəmlərdən istifadə edin, nəticəni yazın və enter düyməsini basın.",
  bavul_desc: "sol tərəfdəki boş bölməyə qoyun ki, çamadan bağlandıqda heç bir əşya ilə üst-üstə düşməsinlər.",
  goremedim: "Görə bilmədim",
  cevapla: "Cavab Verin",
  login: {
    email: "E poçt",
    password: "Şifrə",
    login: "Daxil ol",
    forgot: "Şifrəmi Unutdum"
  },
  app: {
    hello: "salam",
    hello_description: `Alimlər əhval-ruhiyyənin və yuxunun koqnitiv performansa təsir edə biləcəyini sübut etdilər. Öz trendlərinizi izləyə bilmək üçün bu məlumatları qeyd edin.`,
    howareu: "Bugün necəsən?",
    sleep: "Nə qədər yatmısan?",
    save: "Yadda saxla",
    five: "5 və ya daha az",
    nine: "9 və ya daha çox",
    cokkotu: "Çox pis",
    kotu: "Zəif",
    idareeder: "Çox da pis deyil",
    good: "Yaxşı",
    super: "Əla!"
  },
  header: {
    tests: "Testlər",
    logout: "Çıxış",
    home: "ƏSAS EKRAN",
    education: "TƏLİMLƏR",
    exercises: "MƏŞQLƏR"
  },
  pause: {
    paused: "Fasilə verdi",
    continue: "Davam etmək üçün klikləyin"
  },
  coursedetail: {
    step: "Məşq",
    second: "saniyə",
    start: "BAŞLA",
    confirm: "Məşq hələ bitməyib,  çıxsanız bu məşqin məlumatları yadda saxlanılmayacaq.",
    done: "Bu günkü məşqləri bitirdiniz.",
    zoom: "Ortada gördüyünüz qutu böyük və ya kiçikdirsə, onu sağdakı düymələr və ya yuxarı sağdakı düymələr ilə böyüdə bilərsiniz."
  },
  courses: {
    courses: "təlimlər",
    description: `Sizin üçün xüsusi olaraq müəyyən edilmiş bu təlimlə;<br />
    - Göz əzələlərini məşq edəcək<br />
    -Gözlərinizin daha çevik görməsini təmin edəcək<br />
    - Görmə sahənizi genişləndirəcək,<br />
    - Gözləriniz cizgilərdə daha sürətli və daha effektiv şəkildə ritmlənir
    qalib gələcək,<br />
    Beləliklə, görmə + qavrayış harmoniyasını təmin edərək daha sürətli oxuyacaqsınız.`,
    total_day: "Ümumi kurs müddəti:",
    finished_day: "Bitən gün: {day}",
    day: "Gün",
    canrepeat: "Təkrar edilə bilən  {day} gün və {exercise} məşq var.",
    repeat: "Təkrar Et",
    repeat_step: "{step}. Gün",
    start_repeat: "Təkrara Başla",
    continue_repeat: "Təkrara Davam Et",
    start: "Başla"
  },
  edetail: {
    start: "BAŞLA"
  },
  e: {
    welcome: "Məşqlərə xoş gəldin",
    description: `Sürətli oxumağın inkişafı üçün lazım olan hər hansı məşq növünü seçib başlaya bilərsiniz.`
  },
  cats: {
    "Göz Egzersizleri": "Göz məşqləri",
    "Dikkat & Odaklanma": "Diqqət & cəmləmək",
    Hız: "Sürət",
    Hafıza: "Yaddaş",
    "Okuma & Anlama": "Oxuma & qavrama",
    test: "Oxu sürəti testi",
    "Zihinsel Matematik": "Əqli Riyaziyyat"
  },
  module: {
    start: "BAŞLA",
    speed: "Sürət",
    object_count: "Bbyektlərin sayı",
    eksen: "EKSEN",
    direction: "EKSEN",
    horizontal: "Üfüqi",
    vertical: "Şaquli",
    autolevel: "AVTOMATİK ARTIM",
    yes: "Bəli",
    no: "Xeyir",
    time: "ZAMAN",
    level: "SƏVİYYƏ",
    rows: "SƏTİR",
    cols: "SÜTUN",
    benzerkelimeler: {
      description: "Fərqli sözlər olan blokları işarələyin."
    },
    wordperminute: "Söz/Dəqiqə",
    start_again: "Təkrar Başla",
    charlevel: "XARAKTER SƏVİYYƏSİ",
    screenwidth: "EKRAN ENİ",
    screenheight: "EKRAN HÜNDÜRLÜYÜ",
    short: "QISA",
    mid: "ORTA",
    long: "UZUN",
    cevrefokus: {
      description: "Ekranda gördüyünüz söz/sözləri yazın"
    },
    group: "QRUP& QRUP DEYİL",
    same: "EYNİ & EYNİ DEYİL",
    mode: "rejim",
    isgroup: "QRUP",
    issame: "EYNİ",
    isnotgroup: "QRUP DEYİL",
    isnotsame: "EYNİ DEYİL",
    level_completed: "Fəsil Tamamlandı",
    point: "Xalınız:",
    continue: "Davam Et",
    show_time: "İŞlƏMƏ VAXTI",
    farkliolan: {
      description: "Dilini pozan simvolları işarələyin"
    },
    showing_word: "VURĞULANMIŞ SÖZ",
    marquee: "Sürüşən mətin",
    start_again: "Təkrar Başla",
    read_speed: "Oxuma Sürətiniz: {speed} söz/dəqiqə",
    attention: "DİQQƏT REJİMİ",
    open: "AÇIQ",
    close: "BAĞLI",
    image: "RƏSİM",
    gozesnetme: {
      description: `{seconds} saniyə üçün yuxarıdakı rəqəm neçə saniyə çəkəcək?
      Çıxdığınız vaxtları saymaq lazımdır.<br /><br />`,
      question: `<br />
      Yuxarıdakı rəqəmi neçə dəfə görmüsünüz?<br /><br />`
    },
    grupokuma: {
      level: "Gizli {level} söz",
      marquee: "Sürüşən yazı"
    },
    finished: "Bitdi",
    hafiza: {
      des1: "Rəngli Kvadratları Ağlınızda Saxlayın",
      des2: "Kvadratları İşarələyin"
    },
    point: "Hesab",
    level: "Səviyyə",
    total_true: "Ümumi düz",
    total_false: "Ümumi Səhv:",
    isabet: "Vuruş dərəcəsi:",
    reaction: "Şəkil Başına Reaksiya Müddəti:",
    seconds: "saniyə",
    start_again: "Təkrar Başla",
    hafizandatut: {
      desc: "Ekrandakı kart<br />əvvəlki  kartla eynidirmi?<br />"
    },
    time: "Müddət",
    different: "Fərqli",
    same: "Eyni",
    which_bigger: "Hansi Daha Böyük?",
    timeisend: "Vaxt Bitdi<br /> Xalınız: {point}<br />",
    left: "Soldakı",
    allsame: "İkisidə Eyni",
    right: "Sağdakı",
    view_time: "GÖRSƏNMƏ VAXTI",
    letter_count: "HƏRF SAYI",
    harfsayma: {
      description: `Kac adet {currentLetter} var?`
    },
    hizlisecim: {
      description: "Ekrandaki şəkil və rəng<br />əvvəlki şəkil və rəng ile eydirmi?<br />",
      different: "Fərqli",
      same: "Eyni"
    },
    text_length: "MƏTİN UZUNLUĞU",
    kelimeavi: {
      description: 'Oxu mətnində "{currentLetter}" söz(lər)ini tapın'
    },
    siralama: {
      desc: `Baxış sahənizi kəskinləşdirin və ən hündür qülləni tikin. Qutularda görünəcək rəqəmləri kiçikdən böyüyə doğru ardıcıllıqla basın.`,
      start: "Başa düşdüm, Başlaya bilərik!",
      starat: "Başa düşdüm, Başlaya bilərik!"
    },
    tak: {
      placeholder: "Ekranda gördüyünüz söz/sözləri yazın"
    },
    zikzak: {
      desc: `<br />
      Yuxarıdakı rəngi <br />neçə dəfə görmüsünüz?<br /><br />`,
      dikkat: `<br />
      {time} saniyə ərzində yuxarıdakı rəngin<br />nə qədər
      Çıxdığın vaxtları saymalısan<br /><br />`
    }
  },
  home: {
    exercises: "MƏŞQLƏRİM",
    welcome: "Xoş gəldin",
    stats: "Oxuma Sürəti Statistikası",
    last_speed: "Son Oxuma Sürəti",
    last_under: "Son Başa düşmə dərəcəsi ",
    first_speed: "İlk Oxuma Sürəti",
    first_under: "İlk Başa düşmə Dərəcəsi",
    gain: "İnkişaf Trayektoriyası",
    read: {
      title: "Başlamadan Əvvəl Oxuma Sürətini Ölçməliyik",
      desc: `Biz sizə qısa mətni oxutduracaq və oxuduğunuz mətn haqqında qısa xülasə verəcəyik.
      Suallar verəcəyik. Bu test oxuma sürətinizi müəyyən etməyə kömək edir.
      Bu kömək edəcək.`,
      start: "Testə Başla"
    },
    kdk: " k/dk",
    reading_speed: "Oxuma Sürəti",
    unders: "Anlama Dərəcəsi",
    start_date: "Başlama tarixi",
    exam_stats: "Sualın həlli sürəti statistikası",
    tepki: "Cavab Vaxtının Təkmilləşdirilməsi",
    eniyi: "Ən yaxşısı:",
    milisaniye: "millisaniyə",
    dikkat: "Diqqət və Konsentrasiyanın inkişafı",
    enyuksek: "Ən yüksək xal:",
    hafiza: "Yaddaşın inkişafı",
    zihinsel: "Zehni Riyaziyyatın İnkişafı"
  },
  modules: {
    "Soru Egzersizi": "Sual Məşqi",
    "Göz Kasları Esnetme": "Göz əzələlərini gücləndirmə",
    "İkili & Üçlü Kolon": "İkili & Üçlü Sütun",
    "Görme Alanı": "Görmə Sahəsi",
    "Göz Ritmi": "Göz Ritmi",
    "Sıralı Nesneler": "Ardıcıl Obyektlər",
    "Say Bakalım": "Say ",
    "Farkı Bul": "Fərqi Tap",
    "Kelime Avı": "Söz  Ovu",
    Takistoskop: "Taksistoskop",
    "Çoklu Odak": "Multifokus",
    "Çevre Fokus": "Ekoloji diqqət",
    "Blok Okuma": "Blok Oxu",
    Gölgeleme: "kölgələmə",
    Gruplama: "Qruplaşdırma",
    ZikZak: "ZiqZaq",
    "Geniş Bakış": "Geniş Baxış",
    "Düzelt Bakalım": "Düzəldin",
    "Kelime Yeterliliği": "Söz biliyi",
    "Benzer Kelimeler": "Oxşar Sözlər",
    "Hangisi Büyük?": "Hansı Böyük?",
    Video: "Video",
    "Hızlı Seçim": "Sürətli Seçim",
    "Köstebeği Yakala": "Köstəbəyi tut",
    "Hız Üçgeni": "Sürət Üçbucağı",
    "Hafıza Kareleri": "Yaddaş kvadratları",
    "Dönen Hafıza": "Fırlanan yaddaş",
    "Kare Okuma": "Bucaq oxuma",
    "İleri Seviye Kare Okuma": "Yüksək səviyyə bucaq oxuma",
    Tekerleme: "Yanıltmac",
    "Şiir Okuma": "Şeir Oxuma",
    "Haydi Düzeltelim": "Düzəldək",
    "İleri Seviye Tekerleme": "Yüksək səviyyə yanıltmac oxuma",
    "İleri Seviye Şiir Okuma": "Yüksək səviyyə şeir oxuma",
    Heceleme: "Hecalama",
    "Serbest Okuma": "Sərbəst Oxuma",
    "Kelime Egzersizi": "Söz Məşqi",
    Bavul: "Çamadan",
    "Kar Tanesi": "Qar dənəsi",
    Tangram: "Tangram",
    "İleri Seviye Hızlı Seçim": "Qabaqcıl sürətli seçim"
  },
  speedtest: {
    title: "Sürət testinə xoş gəlmisiz ",
    description: "Aşağıdakı düyməni kliklədiyiniz zaman vaxt başlayacaq. Hazırsınızsa başlayaq!",
    start: "Başla",
    speed: "Oxuma Sürətiniz ",
    kd: "Söz/Dəqiqə",
    time: "Keçən zaman {time} saniyə",
    desc2: "Əgər mətni başa düşdüyünüzü düşünürsüzsə,mətinlə bağlı suallara keçə bilərik.",
    hatirlatma: " Nəzərinizə çatdırmaq istərdim ki, əgər başa düşmək qabiliyyətiniz 50%-dən azdırsa,bu mətni təkrarlamalısınız.",
    sorularagec: "suallara keçin",
    metnedon: "mətnə qayıt",
    hesaplamatamam: "Hesablama tamamlandı",
    anlamaorani: "Anlama Dərəcəsi",
    geri: "Geri",
    hesapla: "Hesabla",
    bitti: "Bitdi"
  },
  golge: {
    mode_1: "Silinərək kölgələmə",
    mode_2: "Silinmədən Kölgələmə",
    mode_3: "Oxunan Kölgələmə",
    mode_4: "Yazılı qol"
  },
  menu: {
    tests: "Testlər",
    logout: "Çıxış",
    home: "ƏSAS EKRAN",
    courses: "TƏLİMLƏR",
    exercises: "MƏŞQLƏR"
  },
  gelisim: "Oxumağın inkişafı",
  sorugelisim: "Sualların oxunmasının inkişafı"
};



// WEBPACK FOOTER //
// ./src/languages/az.js